import { FC, ReactElement } from "react"

import styles from "./XList.module.scss"
import {XIcons} from "../XIcons"

export type XListProps = {
  children?: any
}

export type XListExtensions = {
  Tagged: typeof Tagged,
  Carded: typeof Carded,
  Item: typeof Item
}

export type ItemExtensions = {
  Image: typeof Image
  Data: typeof Data
  Arrow: typeof Arrow
}

export type XListItemProps = {
  children?: any
  style?: any
  selected: boolean
  onClick: (item: any) => void
}

export type TaggedProps = {
  children?: any
  style?: any
}

export const XList: FC<XListProps> & XListExtensions = ({
  children
}) => {
  return (
    <>
      <div>
        {children}
      </div>
    </>
  )
}

export const Carded: FC<TaggedProps> = ({
  children, style = {}
}) => {
  return (
    <>
      <div className={styles.xcarded} style={style}>
        {children}
      </div>
    </>
  )
}

export const Tagged: FC<TaggedProps> = ({
  children
}) => {
  return (
    <>
      <div className={styles.xusers}>
        {children}
      </div>
    </>
  )
}

export const Item: FC<XListItemProps> & ItemExtensions = ({
  selected, onClick, children, style = {}
}) => {
  return (
    <>
      <div onClick={() => onClick(null)} className={styles.xusers_item + (selected ? " " + styles.active : "")} style={style}>
        {children}
      </div>
    </>
  )
}

export type XListImageProps = {
  src: string
  icon?: string
}

export const Image: FC<XListImageProps> = ({
  src, icon = ""
}) => {
  return (
    <>
      <div className={styles.xui_img} style={{backgroundImage: `url(${src})`}}>{icon != "" ? <XIcons name={icon} /> : ""}</div>
    </>
  )
}

export type XListDataProps = {
  name?: string | ReactElement
  price?: string | ReactElement
  children?: any
}

export const Data: FC<XListDataProps> = ({
  name = "", price = "", children
}) => {
  return (
    <>
      <div className={styles.xui_data}>
        {typeof name == "string" ? <div dangerouslySetInnerHTML={{__html: (name as string)}}></div> : <div>{name}</div>}
        {typeof price == "string" ? <div dangerouslySetInnerHTML={{__html: (price as string)}}></div> : <div>{price}</div>}
        {/* <div>{price}</div> */}
        {children}
      </div>
    </>
  )
}

export const Arrow: FC = () => {
  return (
    <>
      <div className={styles.xui_arrow}><XIcons name="s chevron-right" /></div>
    </>
  )
}

XList.Item = Item
XList.Tagged = Tagged
XList.Carded = Carded

Item.Image = Image
Item.Data = Data
Item.Arrow = Arrow